import { Moment } from 'moment';

import {
  EmployeeLicenseStatus,
  EmployeeLicenseWarning,
  States,
} from '../enums';
import { makeUnix } from './Model';

const SORT_LICENSE_STATUS = new Map<EmployeeLicenseStatus, number>([
  [EmployeeLicenseStatus.ACTIVE, 0],
  [EmployeeLicenseStatus.APPLICATION_IN_PROGRESS, 5],
  [EmployeeLicenseStatus.APPLICATION_SUBMITTED, 5],
  [EmployeeLicenseStatus.ENDORSEMENT_SUBMITTED, 5],
  [EmployeeLicenseStatus.EXPIRED, 10],
  [EmployeeLicenseStatus.INACTIVE, 15],
  [EmployeeLicenseStatus.INACTIVE_DUE_PSOR, 15],
]);
export class EmployeeLicense {
  expiresAt?: Moment;

  licenseNumber = '';

  issuedAt?: Moment;

  state?: States;

  status?: EmployeeLicenseStatus;

  warning?: EmployeeLicenseWarning;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.expiresAt = makeUnix(obj.expiresAt);
    this.issuedAt = makeUnix(obj.issuedAt);
    this.state = States.byKey[obj.state];
    this.status = EmployeeLicenseStatus.byKey[obj.status];
    this.warning = EmployeeLicenseWarning.byKey[obj.warning];
  }

  static sortByStatus(a: EmployeeLicense, b: EmployeeLicense): number {
    if (a.status && b.status && a.status !== b.status) {
      return (
        (SORT_LICENSE_STATUS.get(a.status) || 0) -
        (SORT_LICENSE_STATUS.get(b.status) || 0)
      );
    }
    return a.state?.toString()?.localeCompare(b.state?.toString() || '') || 0;
  }
}

export default EmployeeLicense;
